import React from 'react';
import type { RangeSliderProps} from '@Components/range-slider';
import {RangeSlider} from '@Components/range-slider';
import './trim-range-slider.scss';

interface TrimRangeProps extends RangeSliderProps {
  minGap: number;
}

// to be kept the same as ./trim-range-slider.scss
const className = 'trimRangeSlider';
const defaultStep = 0.1;
const containerClassName = 'trimRangeSliderContainer';

export function TrimRangeSlider({...props}: TrimRangeProps) {
  return (
    <div className={`${containerClassName}`}>
      <RangeSlider className={`${className} ${props.className}`} pushable={props.minGap} allowCross={false} step={props.step ?? defaultStep} {...props} />
    </div>
  );
}
